// extracted by mini-css-extract-plugin
export var image = "dualImage-module--image--d5aea";
export var imageWrapper = "dualImage-module--imageWrapper--1e9a3";
export var subtitle = "dualImage-module--subtitle--39852";
export var wrapper = "dualImage-module--wrapper--4877d";